import { render, staticRenderFns } from "./innerlayerUdi.vue?vue&type=template&id=56a27fd0&scoped=true&"
import script from "./innerlayerUdi.vue?vue&type=script&lang=js&"
export * from "./innerlayerUdi.vue?vue&type=script&lang=js&"
import style0 from "./innerlayerUdi.vue?vue&type=style&index=0&id=56a27fd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a27fd0",
  null
  
)

export default component.exports